import React from 'react';
import {
  Button,
  Modal,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Spin,
  Table,
  Select,
} from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useEffect, useState, useRef } from 'react';
import { API, BEARER } from '../../constant';
import ItemListDisplay from '../../components/ItemList/ItemListDispaly';
import { getToken } from '../../helpers';
import { CSVLink } from 'react-csv';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import {
  getMonthNameFromStringDate,
  compareMonth,
  sortRecordsByMonth,
  sortRecordsBySeason,
} from '../../utils/dateUtils';
import { errorHandler } from '../../utils/errorHandling';
import { DeleteRequestFactory } from '../../utils/DeleteRequestFactory';

const userRoleAndPermission = require('../../config/userPermision.json');
const userRolesAllowedForAttributes = {
  edit: {
    designAttribute: [
      ...userRoleAndPermission?.userRole?.designTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    merchAttribute: [
      ...userRoleAndPermission?.userRole?.merchTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    planningAttribute: [
      ...userRoleAndPermission?.userRole?.planningTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
  },
  view: {},
};

// const filterGlobalSearch = (Data, searchText, filterScope) => {
//   if (!searchText) {
//     return Data;
//   }

//   let filteredDataTemp = [];
//   if (filterScope == 'all') {
//     filteredDataTemp = Data.filter((value) => {
//       console.log(value);
//       return value.launchDetails?.launchName
//         ?.toLowerCase()
//         .includes(searchText.trim().toLowerCase()) ||
//         value.launchDetails?.launchDrop
//           ?.toLowerCase()
//           .includes(searchText.trim().toLowerCase()) ||
//         value.launchDetails?.launchCategory
//           ?.toLowerCase()
//           .includes(searchText.trim().toLowerCase()) ||
//         value.launchDetails?.seasonDetails?.seasonId
//           ?.toLowerCase()
//           .includes(searchText.trim().toLowerCase()) ||
//         value.month?.toLowerCase().includes(searchText.trim().toLowerCase()) ||
//         value?.productOptionDetails?.filter((poqObj) =>
//           poqObj?.poObject?.productCatName
//             ?.toLowerCase()
//             .includes(searchText.trim().toLowerCase())
//         )?.length > 0
//         ? true
//         : false ||
//             value.status
//               ?.toLowerCase()
//               .includes(searchText.trim().toLowerCase());
//     });
//   } else if (filterScope == 'launchName') {
//     filteredDataTemp = Data.filter((value) => {
//       return value.launchDetails?.launchName
//         ?.toLowerCase()
//         .includes(searchText.trim().toLowerCase());
//     });
//   } else if (filterScope == 'launchDrop') {
//     filteredDataTemp = Data.filter((value) => {
//       return value.launchDetails?.launchDrop
//         ?.toLowerCase()
//         .includes(searchText.trim().toLowerCase());
//     });
//   } else if (filterScope == 'month') {
//     filteredDataTemp = Data.filter((value) => {
//       return value.month
//         ?.toLowerCase()
//         .includes(searchText.trim().toLowerCase());
//     });
//   }

//   console.log(filteredDataTemp, 'filtered data', filterScope, searchText);
//   if (filteredDataTemp.length > 0) {
//     return filteredDataTemp;
//   } else {
//     filteredDataTemp.push({
//       key: 0,
//       id: 0,
//       month: 'Not Found',
//       type: 'Not Found',
//       status: false,
//       totalUnits: 0,
//       totalOptionQty: 0,
//       launchDetails: {
//         launchRefId: 0,
//         launchName: 'Not Found',
//         launchCategory: 'Not Found',
//         launchMonth: 'Not Found',
//         launchDrop: 'Not Found',
//         launchDate: 0,
//         seasonDetails: {
//           seasonId: 'Not Found',
//         },
//       },
//       productOptionDetails: [],
//     });
//     return filteredDataTemp;
//   }
// };

const OtbRecordList = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [paginationData, setPaginationData] = useState({});
  // pagination object data for configuration.
  const [paginationParams, setPaginationParams] = useState({});
  // pagination parameter changed by user

  const [isLoading, setIsLoading] = useState(null);
  const [isDownloading, setIsDownloading] = useState(null);
  const authToken = getToken();
  const [Data, setData] = useState([]);

  const [seasonMasterList, setSeasonMasterList] = useState([]);

  const [filterInfo, setFilterInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState('');

  const [filterScope, setFilterScope] = useState('all');

  // CSV Export
  const [downloadableData, setDownloadableData] = useState([]);
  const csvLinkRef = useRef();

  const filterScopeOptionsArray = ['all', 'launchName', 'launchDrop', 'month'];

  const [alreadySelectedRows, setAlreadySelectedRows] = useState([]);
  const currentPage = parseInt(searchParams.get('page'), 10) || 1;
  const searchString = searchParams?.get('searchquery') || '';
  const [searchText, setSearchText] = useState(searchString || null);

  console.log(
    'search parametere received',
    searchParams.get('page'),
    searchParams.get('searchquery'),
    currentPage,
    searchString,
    searchText,
  );

  const toOtbRecordDetails = (state) => {
    navigate('/OtbDetails', { state });
  };

  let data1 = [];

  const getUserdDetailsCreatedBy = async (entry, contentTypeName) => {
    const userDetailsResponse = await fetch(
      `${API}/auditlogs?filters[$and][0][contentType][$eq]=${contentTypeName}&filters[$and][0][activity][$eq]=create&filters[$and][0][resourceId][$eq]=${entry?.id}&sort=createdAt:desc`,
      {
        headers: { Authorization: `${BEARER} ${getToken()}` },
      },
    );
    const userDetailsResponseData = await userDetailsResponse.json();
    console.log(
      userDetailsResponseData,
      'userDetailsResponse check',
      'Resouce Details',
      entry?.id,
    );

    return {
      userRefId: userDetailsResponseData?.data[0]?.attributes?.user?.id,
      userName: userDetailsResponseData?.data[0]?.attributes?.user?.username,
      userEmail: userDetailsResponseData?.data[0]?.attributes?.user?.email,
    };
  };

  const getRelatedActualCPs = async (token, otbRecordId) => {
    const userDetailsResponse = await fetch(
      `${API}/otb-record/get-related-cps?sort=createdAt:desc`,
      {
        headers: { Authorization: `${BEARER} ${getToken()}` },
      },
    );
  };

  const getRelatedCPSnew = async (token, filterText) => {
    // console.log('related cps', token);
    try {
      setIsDownloading(true);
      const requestedAdditionalDetails = {
        populate: [
          {
            relation: 'launch_masters',
            populate: [
              {
                relation: 'season',
                populate: null,
              },
            ],
          },
          {
            relation: 'product_option',
            populate: null,
          },
          {
            relation: 'product_option_type',
            populate: null,
          },
          {
            relation: 'planning_prod_sub_cat',
            populate: null,
          },
          {
            relation: 'planning_prod_optn_type',
            populate: null,
          },
          {
            relation: 'collection',
            populate: null,
          },
        ],
        filters: {
          fieldsFilterConfig: [
            {
              fieldName: 'id',
              path: 'this',
              operation: 'eq',
            },
            {
              // done
              fieldName: 'launchDrop',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'month',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'sku',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'status',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'object_status',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'object_status_no',
              path: 'this',
              operation: 'containsi',
            },
            {
              // done
              fieldName: 'launchName',
              path: 'this.launch_masters',
              operation: 'containsi',
            },
            {
              // done
              fieldName: 'launchId',
              path: 'this.launch_masters',
              operation: 'eqi',
            },
            {
              // done
              fieldName: 'season_id',
              path: 'this.launch_masters.season',
              operation: 'containsi',
            },
            {
              fieldName: 'launchDrop',
              path: 'this.launch_masters',
              operation: 'containsi',
            },

            {
              fieldName: 'launchCat',
              path: 'this.launch_masters',
              operation: 'containsi',
            },
            {
              fieldName: 'productCategoryName',
              path: 'this.product_option_type',
              operation: 'containsi',
            },
            {
              fieldName: 'supplierName',
              path: 'this.supplier_master',
              operation: 'containsi',
            },
            {
              fieldName: 'Indent_file_reference_id',
              path: 'this.indent_sheets',
              operation: 'containsi',
            },
            {
              fieldName: 'techpack_file_reference_id',
              path: 'this.techpacks',
              operation: 'containsi',
            },
            {
              fieldName: 'fabricName',
              path: 'this.fabric_used_for_products.fabric',
              operation: 'containsi',
            },
            {
              fieldName: 'supplierName',
              path: 'this.fabric_used_for_products.supplier_master',
              operation: 'containsi',
            },
          ],
          searchString: filterText,
          currentFilter: [
            'id',
            'launchDrop',
            'month',
            'sku',
            'launchName',
            'launchId',
            'season_id',
            'launchCat',
            'productCategoryName',
            'supplierName',
            'fabricName',
            'Indent_file_reference_id',
            'techpack_file_reference_id',
          ],
          andFilter: [
            {
              fieldName: 'object_status',
              operation: 'ne',
              searchString: 'receiving_due',
            },
            {
              fieldName: 'object_status_no',
              operation: 'lte',
              searchString: 6,
            },
          ],
        },
        sort: {
          createdAt: 'desc',
        },
      };
      const data = { data: { requestedAdditionalDetails } };
      const response = await fetch(`${API}/otb-record/get-related-cps`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${BEARER} ${token}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log(responseData, 'response check related CPs');
      // return true;
      if (responseData?.error) {
        errorHandler(responseData, message);
      } else {
        // return;
        if (responseData?.data) {
          let actualizedCPCKeys = Object.keys(responseData?.data);
          const actualProductionByCatagory = responseData?.data;
          let relatedCPsArray = [];

          if (actualizedCPCKeys?.length > 0) {
            for (let i = 0; i < actualizedCPCKeys.length; i++) {
              let key = actualizedCPCKeys[i];
              console.log(
                'cpProductOption ',
                key,
                actualProductionByCatagory[key][0].id,
                actualProductionByCatagory[key][0].productCategoryName,
              );

              let productOptionObject = actualProductionByCatagory[key][0];
              let poqId = key;
              let quantity = actualProductionByCatagory[key].length;
              let poObject = {
                productCatName:
                  actualProductionByCatagory[key][0].productCategoryName,
                productCatId: actualProductionByCatagory[key][0].id,
              };

              let cpRelatedObject = { poqId, quantity, poObject };
              console.log('product new -- ', cpRelatedObject);
              relatedCPsArray.push(cpRelatedObject);
            }
            console.log('related CPs array:', relatedCPsArray);
          }

          return relatedCPsArray;
        }
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsDownloading(false);
    }
  };

  const fetchDataAll = async (token) => {
    try {
      setIsDownloading(true);
      const requestedAdditionalDetails = {
        populate: [
          {
            relation: 'launch_master',
            populate: [
              {
                relation: 'season',
                populate: null,
              },
            ],
          },
          {
            relation: 'product_option_qties',
            populate: [
              {
                relation: 'product_option_type',
                populate: null,
              },
            ],
          },
        ],
        filters: {
          fieldsFilterConfig: [
            {
              fieldName: 'id',
              path: 'this',
              operation: 'eq',
            },
            {
              fieldName: 'month',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'status',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'type',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'launchName',
              path: 'this.launch_master',
              operation: 'containsi',
            },
            {
              fieldName: 'launchDrop',
              path: 'this.launch_master',
              operation: 'containsi',
            },
            {
              fieldName: 'launchCat',
              path: 'this.launch_master',
              operation: 'containsi',
            },
            {
              fieldName: 'season_id',
              path: 'this.launch_master.season',
              operation: 'containsi',
            },
            {
              fieldName: 'productCategoryName',
              path: 'this.product_option_qties.product_option_type',
              operation: 'containsi',
            },
          ],
          searchString: searchText?.trim()?.toLowerCase() ?? '',
          currentFilter: [
            'id',
            'month',
            'type',
            'launchName',
            'launchCat',
            'launchDrop',
            'season_id',
            'productCategoryName',
          ],
        },
        sort: {
          createdAt: 'desc',
        },
      };
      const data = { data: { requestedAdditionalDetails } };
      const response = await fetch(`${API}/otb-record/get-populated-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${BEARER} ${token}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log(responseData, 'response check fetch all');
      if (responseData.error) {
        errorHandler(responseData, message);
      } else {
        // return;

        data1 = await Promise.all(
          responseData?.data?.completeSuccess?.map(async (entry) => {
            console.log('otb record populated received : ', entry);
            // return false;
            // Fetch User Details
            const userDetails = {
              userRefId: entry?.userDetails[0]?.user?.userID,
              userName: entry?.userDetails[0]?.user?.username,
              userEmail: entry?.userDetails[0]?.user?.email,
            };
            let launchObj = {};
            if (entry?.launch_master) {
              let launchMasterObject = entry?.launch_master;
              launchObj = {
                launchRefId: launchMasterObject?.id,
                launchName: launchMasterObject?.launchName,
                launchCategory: launchMasterObject?.launchCat,
                launchMonth: launchMasterObject?.launchMonth,
                launchDrop: launchMasterObject?.launchDrop,
                launchDate: launchMasterObject?.launchDate,
                launchDate: launchMasterObject?.launchDate,
                seasonDetails: {
                  seasonId: launchMasterObject?.season?.season_id,
                  seasonRefId: launchMasterObject?.season?.id,
                },
              };
            }

            let productOptionList = [];
            if (entry?.product_option_qties?.length > 0) {
              productOptionList = entry?.product_option_qties?.map(
                (productOptionQtyObject) => {
                  let productOptionObject =
                    productOptionQtyObject?.product_option_type;
                  let poqId = productOptionQtyObject?.id;
                  let quantity = productOptionQtyObject?.quantity;
                  let poObject = {
                    productCatName: productOptionObject?.productCategoryName,
                    productCatId: productOptionObject?.id,
                  };

                  return { poqId, quantity, poObject };
                },
              );
            }

            return {
              key: entry?.id,
              id: entry?.id,
              month: entry?.month,
              type: entry?.type,
              status: entry?.status,
              totalUnits: entry?.totalUnits,
              totalOptionQty: entry?.totalOptionQty,
              launchDetails: launchObj,
              productOptionDetails: productOptionList,
              userDetails: userDetails,
              createdAt: entry?.createdAt,
              updatedAt: entry?.updatedAt,
            };
          }),
        );

        console.log('original Data fetch all:', responseData);
        console.log('current Data after modification fetch all:', data1);
        // setData(await sortRecordsByMonth(data1));
        const finalDownloadData = data1;
        console.log('final filtered data fetch all:', finalDownloadData);
        return finalDownloadData;
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsDownloading(false);
    }
  };

  const fetchDataFull = async (token, additionalData = '') => {
    //can be modified additionalData?.currentPageNew || currentPage
    let searchStringFinal = additionalData?.searchParameters || searchText;
    setIsLoading(true);
    try {
      const requestedAdditionalDetails = {
        populate: [
          {
            relation: 'launch_master',
            populate: [
              {
                relation: 'season',
                populate: null,
              },
            ],
          },
          {
            relation: 'product_option_qties',
            populate: [
              {
                relation: 'product_option_type',
                populate: null,
              },
            ],
          },
        ],
        filters: {
          fieldsFilterConfig: [
            {
              fieldName: 'id',
              path: 'this',
              operation: 'eq',
            },
            {
              fieldName: 'month',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'status',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'type',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'launchName',
              path: 'this.launch_master',
              operation: 'containsi',
            },
            {
              fieldName: 'launchDrop',
              path: 'this.launch_master',
              operation: 'containsi',
            },

            {
              fieldName: 'launchCat',
              path: 'this.launch_master',
              operation: 'containsi',
            },
            {
              fieldName: 'season_id',
              path: 'this.launch_master.season',
              operation: 'containsi',
            },
            {
              fieldName: 'productCategoryName',
              path: 'this.product_option_qties.product_option_type',
              operation: 'containsi',
            },
          ],
          searchString: searchStringFinal || '',
          currentFilter: [
            'id',
            'month',
            'status',
            'type',
            'launchName',
            'launchCat',
            'launchDrop',
            'season_id',
            'productCategoryName',
          ],
        },
        sort: {
          createdAt: 'desc',
        },
      };
      const data = { data: { requestedAdditionalDetails } };
      const response = await fetch(`${API}/otb-record/get-populated-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${BEARER} ${token}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log(responseData, 'response check');
      if (responseData.error) {
        errorHandler(responseData, message);
      } else {
        // return;
        // setPaginationData(responseData?.meta?.pagination);
        data1 = responseData?.data?.completeSuccess?.map((entry) => {
          // Fetch User Details
          const userDetails = {
            userRefId: entry?.userDetails[0]?.user?.userID,
            userName: entry?.userDetails[0]?.user?.username,
            userEmail: entry?.userDetails[0]?.user?.email,
          };
          // End Fetch User Details

          let launchObj = {};
          if (entry?.launch_master) {
            let launchMasterObject = entry?.launch_master;
            launchObj = {
              launchRefId: launchMasterObject?.id,
              launchName: launchMasterObject?.launchName,
              launchCategory: launchMasterObject?.launchCat,
              launchMonth: launchMasterObject?.launchMonth,
              launchDrop: launchMasterObject?.launchDrop,
              launchDate: launchMasterObject?.launchDate,
              launchDate: launchMasterObject?.launchDate,
              seasonDetails: {
                seasonId: launchMasterObject?.season?.season_id,
                seasonRefId: launchMasterObject.data?.season?.id,
              },
            };
          }

          let productOptionList = [];
          if (entry?.product_option_qties?.length > 0) {
            productOptionList = entry?.product_option_qties.map(
              (productOptionQtyObject) => {
                let productOptionObject =
                  productOptionQtyObject?.product_option_type;
                let poqId = productOptionQtyObject?.id;
                let quantity = productOptionQtyObject?.quantity;
                let poObject = {
                  productCatName: productOptionObject?.productCategoryName,
                  productCatId: productOptionObject?.id,
                };

                return { poqId, quantity, poObject };
              },
            );
          }

          return {
            key: entry?.id,
            id: entry?.id,
            month: entry?.month,
            type: entry?.type,
            status: entry?.status,
            totalUnits: entry?.totalUnits,
            totalOptionQty: entry?.totalOptionQty,
            launchDetails: launchObj,
            productOptionDetails: productOptionList,
            userDetails: userDetails,
            createdAt: entry?.createdAt,
            updatedAt: entry?.updatedAt,
          };
        });

        console.log('original Data:', responseData);
        console.log('current Data after modification:', data1);
        // setData(await sortRecordsByMonth(data1, true));
        setData(data1);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async (token, additionalData = '') => {
    setIsLoading(true);
    try {
      //  ${
      //     location?.state && `&filters[otb_record][id][$eq]=${location?.state}`
      //   }
      // can be modified  : additionalData?.currentPageNew || currentPage
      const paginationParameter = `pagination[page]=${
        additionalData?.currentPageNew || currentPage
      }&pagination[pageSize]=${10}&pagination[withCount]=true`;
      const queryString = [
        `populate[launch_master][populate][0]=season`,
        'populate[product_option_qties][populate][1]=product_option_type',
        paginationParameter,
        additionalData?.searchParameters,
        `sort=createdAt:desc`,
      ]
        .filter(Boolean)
        .join('&');

      console.log(
        'search and other option functionality',
        additionalData,
        'query : ',
        `${API}/otb-records?${queryString}`,
      );
      const response = await fetch(`${API}/otb-records?${queryString}`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const responseData = await response.json();
      console.log(responseData, 'response check');
      if (responseData.error) {
        errorHandler(responseData, message);
      } else {
        setPaginationData(responseData?.meta?.pagination);
        // setSearchParams({ page: current });

        data1 = await Promise.all(
          responseData?.data?.map(async (entry) => {
            console.log(
              'Current otb record details',
              entry?.attributes?.launch_master?.data?.attributes?.launchName,
              entry?.attributes?.launch_master?.data?.attributes?.launchId,
            );
            // Fetch User Details
            const userDetails = await getUserdDetailsCreatedBy(
              entry,
              'otb-records',
            );
            let relatedCPS;
            if (entry?.attributes?.launch_master?.data?.attributes?.launchId) {
              relatedCPS = await getRelatedCPSnew(
                token,
                entry?.attributes?.launch_master?.data?.attributes?.launchId,
              );
            }

            // End Fetch User Details
            console.log('cp related : ', relatedCPS);
            // return false;
            let launchObj = {};
            if (entry?.attributes?.launch_master) {
              let launchMasterObject = entry?.attributes?.launch_master;
              launchObj = {
                launchRefId: launchMasterObject?.data?.id,
                launchName: launchMasterObject?.data?.attributes?.launchName,
                launchCategory: launchMasterObject?.data?.attributes?.launchCat,
                launchMonth: launchMasterObject?.data?.attributes?.launchMonth,
                launchDrop: launchMasterObject?.data?.attributes?.launchDrop,
                launchDate: launchMasterObject?.data?.attributes?.launchDate,
                launchDate: launchMasterObject?.data?.attributes?.launchDate,
                seasonDetails: {
                  seasonId:
                    launchMasterObject?.data?.attributes?.season?.data
                      ?.attributes?.season_id,
                  seasonRefId:
                    launchMasterObject.data?.attributes?.season?.data?.id,
                },
              };
            }

            // product option details
            let productOptionList = [];
            if (entry?.attributes?.product_option_qties?.data?.length > 0) {
              productOptionList =
                entry?.attributes?.product_option_qties?.data.map(
                  (productOptionQtyObject) => {
                    let productOptionObject =
                      productOptionQtyObject?.attributes?.product_option_type;
                    let poqId = productOptionQtyObject?.id;
                    let quantity = productOptionQtyObject?.attributes?.quantity;
                    let poObject = {
                      productCatName:
                        productOptionObject?.data?.attributes
                          ?.productCategoryName,
                      productCatId: productOptionObject?.data?.id,
                    };

                    return { poqId, quantity, poObject };
                  },
                );
            }

            return {
              key: entry?.id,
              id: entry?.id,
              month: entry?.attributes?.month,
              type: entry?.attributes?.type,
              status: entry?.attributes?.status,
              totalUnits: entry?.attributes?.totalUnits,
              totalOptionQty: entry?.attributes?.totalOptionQty,
              launchDetails: launchObj,
              productOptionDetails: productOptionList,
              cpActualizedDetails: relatedCPS,
              userDetails: userDetails,
              createdAt: entry?.attributes?.createdAt,
              updatedAt: entry?.attributes?.updatedAt,
            };
          }),
        );

        console.log('original Data:', responseData);
        console.log('current Data after modification:', data1);

        // setData(await sortRecordsByMonth(data1));
        setData(data1);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const getSearchParameters = () => {
    let searchParameters = '';
    if (!searchText) {
      return searchParameters;
    }
    let sanitizedSearchText = searchText?.trim()?.toLowerCase() ?? '';
    searchParameters = [
      `filters[$or][0][month][$containsi]=${sanitizedSearchText}`,
      `filters[$or][1][launch_master][launchName][$containsi]=${sanitizedSearchText}`,
      `filters[$or][2][launch_master][season][season_id][$containsi]=${sanitizedSearchText}`,
      `filters[$or][3][launch_master][launchDrop][$containsi]=${sanitizedSearchText}`,
      `filters[$or][4][launch_master][launchCat][$containsi]=${sanitizedSearchText}`,
      `filters[$or][5][product_option_qties][product_option_type][productCategoryName][$containsi]=${sanitizedSearchText}`,
      `filters[$or][6][type][$containsi]=${sanitizedSearchText}`,
      `filters[$or][7][id][$eq]=${sanitizedSearchText}`,
    ]
      .filter(Boolean)
      .join('&');

    return searchParameters;
  };

  useEffect(() => {
    if (authToken) {
      // let searchParameters = searchText;
      // fetchData(authToken, { searchParameters });

      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });

      // fetchData(authToken);
      fetchSeasonList(getToken());
    }
  }, []);

  // pagination related state management.
  useEffect(() => {
    console.log(
      'pagination parameters updated',
      paginationParams,
      paginationData,
    );
    if (paginationParams) {
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });
    } else {
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });
    }
  }, [paginationParams]);

  useEffect(() => {
    console.log(searchText);
    if (paginationData?.page) {
      setSearchParams({
        page: paginationData?.page,

        ...(searchText && { searchquery: searchText }),
      });
    }
  }, [paginationData]);

  useEffect(() => {
    console.log(searchText);
    if (searchText == '') {
      console.log('search Text chaged', searchText, currentPage);
      setSearchParams({ page: 1 });
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters, currentPageNew: 1 });
      // fetchData(authToken);
    } else if (searchText) {
      let searchParameters = getSearchParameters();
      setSearchParams({
        ...(currentPage ? { page: currentPage } : { page: 1 }),
        ...(searchText && { searchquery: searchText }),
      });
      // let searchParameters = searchText;
      fetchData(authToken, { searchParameters, currentPageNew: 1 });
      // fetchData(authToken);
    }
  }, [searchText, filterScope]);

  const toProductOptionPage = (state) => {
    navigate('/productOptionList', { state });
  };

  const fetchSeasonList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/seasons?sort=createdAt:ASC`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData.data.map((entry) => {
        return {
          id: entry.id,
          season_type: entry?.attributes?.season_type,
          season_year: entry?.attributes?.season_year,
          season_id: entry?.attributes?.season_id,
          // launch_masters: entry.attributes.launch_masters,
        };
      });

      setSeasonMasterList(optionsData2);
      console.log('original option Data:', optionsData);
      console.log('modified Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: 'id',
    },
    {
      key: 'seasonId',
      title: 'Season',
      dataIndex: 'seasonId',
      // sorter: (record1, record2) => {
      //   let r1SeasonId = record1.launchDetails?.seasonDetails?.seasonId;
      //   let r2SeasonId = record2.launchDetails?.seasonDetails?.seasonId;

      //   const sessionArr = [
      //     'SS19',
      //     'SS23',
      //     'SS23',
      //     'AW24',
      //     'SS24',
      //     'AW25',
      //     'SS25',
      //     'AW26',
      //     'SS26',
      //     'AW27',
      //     'SS27',
      //   ];

      //   return sessionArr.indexOf(r1SeasonId) > sessionArr.indexOf(r2SeasonId)
      //     ? true
      //     : false;
      // },

      sorter: async (record1, record2, sortOrder) => {
        // return record1.month?.localeCompare(record2.month);
        // return compareMonth(record1.month, record2.month);
        console.log(sortOrder, 'session sort from header');
        const sortingOrderCustomeFunct = sortOrder == 'ascend' ? true : false;
        const seasonslist = seasonMasterList
          .map((season) => season.season_id)
          .filter((value, index, self) => self.indexOf(value) === index);
        console.log(
          sortOrder,
          sortingOrderCustomeFunct,
          seasonslist,
          'season sort from header',
        );
        setData(
          await sortRecordsBySeason(
            Data,
            sortingOrderCustomeFunct,
            seasonslist,
          ),
        );
        return true;
      },
      sortOrder: sortedInfo.columnKey === 'seasonId' && sortedInfo.order,
      render: (_, record) => {
        console.log(record, 241);
        return record?.launchDetails?.seasonDetails?.seasonId;
      },
    },
    {
      key: 'month',
      title: 'Month',
      dataIndex: 'month',
      sorter: async (record1, record2, sortOrder) => {
        // return record1.month?.localeCompare(record2.month);
        // return compareMonth(record1.month, record2.month);
        console.log(sortOrder, 'month sort from header');
        const sortingOrderCustomeFunct = sortOrder == 'ascend' ? true : false;
        console.log(
          sortOrder,
          sortingOrderCustomeFunct,
          'month sort from header',
        );
        setData(await sortRecordsByMonth(Data, sortingOrderCustomeFunct));
        return true;
      },
      // sortDirections: ['ascend', 'descend', 'ascend'],
      sortOrder: sortedInfo.columnKey === 'month' && sortedInfo.order,
    },
    {
      key: 'launchName',
      title: 'Launch Name',
      dataIndex: 'launchName',
      sorter: (record1, record2) => {
        return record1?.launchDetails?.launchName?.localeCompare(
          record2?.launchDetails?.launchName,
        );
      },
      sortOrder: sortedInfo.columnKey === 'launchName' && sortedInfo.order,
      render: (_, record) => {
        return record?.launchDetails?.launchName;
      },
    },
    {
      key: 'launchDrop',
      title: 'Launch Drop',
      dataIndex: 'launchDrop',
      render: (_, record) => {
        return record.launchDetails?.launchDrop;
      },
    },

    {
      key: 'launchCategory',
      title: 'Launch Category',
      dataIndex: 'launchCategory',
      render: (_, record) => {
        return record.launchDetails?.launchCategory;
      },
    },
    {
      key: 'productCategories',
      title: 'Product Categories',
      dataIndex: 'productCategories',
      render: (_, record) => {
        return <ItemListDisplay productOptions={record.productOptionDetails} />;
      },
    },
    {
      key: 'totalOptionQty',
      title: 'Total Planned Option Qty',
      dataIndex: 'totalOptionQty',
    },
    {
      key: 'totalUnits',
      title: 'Total Planned Units',
      dataIndex: 'totalUnits',
    },
    {
      key: 'actualProductsSummary',
      title: 'Actual Product Summary',
      dataIndex: 'actualProductsSummary',
      render: (_, record) => {
        return <ItemListDisplay productOptions={record.cpActualizedDetails} />;
      },
    },
    {
      key: 'type',
      title: 'OTB Type',
      dataIndex: 'type',
    },
    {
      key: 'userName',
      title: 'Username',
      dataIndex: 'userName',
      render: (_, record) => {
        console.log(record, record?.userDetails?.userName);
        return record?.userDetails?.userName ?? 'NA';
      },
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (_, record) => {
        switch (record.status) {
          case 'confirmed':
            return 'confirmed';
            break;
          case 'prod_option_generated':
            return 'Option Generated';
            break;
          default:
            return record.status;
            break;
        }
      },
    },
    {
      key: 'action',
      title: 'Actions',

      render: (_, record) => {
        // if (record.status !== 'prod_option_generated') {
        return (
          <div>
            <div className="ActionColumn">
              <EditOutlined
                data-testid="edit-data-item"
                style={{ color: 'black' }}
                onClick={() => Edit(record)}
              />
              <Button
                data-testid="delete-data-item"
                disabled={record.status === 'prod_option_generated'}
                icon={
                  <DeleteOutlined style={{ color: 'red', marginRight: 8 }} />
                }
                onClick={() => Delete(record)}
              />
            </div>
          </div>
        );
        // }
      },
    },
  ];

  const deleteRecord = async (recordID) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/otb-records/${recordID}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getToken()}`,
        },
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error) {
        errorHandler(responseData, message);
      } else {
        let searchParameters = getSearchParameters();
        fetchData(authToken, { searchParameters });
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const Delete = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this',
      onOk: () => {
        deleteRecord(record.id);
      },
    });
  };

  const Edit = (record) => {
    toOtbRecordDetails(record);
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    console.log('in handle table change', pagination, filters, sorter);
    const { order, columnKey } = sorter;
    setFilterInfo(filters);
    setSortedInfo({ columnKey, order });
    const { current } = pagination;
    setPaginationParams({
      page: pagination?.current,
      pageCount: Math.ceil(pagination?.total / pagination?.pageSize) ?? 0,
      pageSize: pagination.pageSize,
      total: pagination.total,
    });
    setSearchParams({
      page: current,
      ...(searchText && { searchquery: searchText }),
    });
  };

  const resetTable = () => {
    setSortedInfo({});
    setFilterInfo({});
    setSearchText(null);
    setSearchParams({});
    setFilterScope('all');
    setAlreadySelectedRows([]);
    let searchParameters = '';
    fetchData(authToken, { searchParameters, currentPageNew: 1 });
  };

  const handleChangeSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFilterScopeChange = (value) => {
    console.log('setFilterScope', value);
    setFilterScope(value);
  }; // handle change in filter scope

  const getFilterOptionArray = (options) => {
    return options.map((option) => {
      return { value: option, label: option };
    });
  }; //

  const filterOptionArray = [...getFilterOptionArray(filterScopeOptionsArray)];

  const confirmAllselectedRecords = async () => {
    console.log(alreadySelectedRows, 'confirm all selected records func');
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/otb-record/confirm-otb-records`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Operation-Type': 'bulk',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          data: { selectedOTBRecords: alreadySelectedRows },
        }),
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData?.error) {
        errorHandler(responseData, message);
      } else {
        message.success('updated Records successfully');
        fetchData(getToken());
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const otbRecordStatusLookupObject = {
    active: 'Active',
    wip: 'WIP',
    inactive: 'Inactive',
    droped: 'Dropped',
    confirmed: 'Confirmed',
    prod_option_generated: 'Options Generated',
    deleted: 'Deleted',
  };
  const getDisplayableStatus = (sys_status) => {
    return otbRecordStatusLookupObject[sys_status];
  };

  const getFinalFormatedData = async () => {
    const finalDownloadableData = await getFormattedData();
    setDownloadableData(finalDownloadableData);
    setTimeout(() => {
      csvLinkRef.current.link.click(); // Manually trigger CSV download
    }, 600); // Small delay to ensure state update
  };

  const getFormattedData = async () => {
    const downloadData = await fetchDataAll(authToken);
    console.log(downloadData, 'downloading data...');

    let downloadDataFormatted = downloadData?.map((row) => {
      console.log(row, 'downloading data row...');
      return {
        Id: row?.id,
        'Season ID': row?.launchDetails?.seasonDetails?.seasonId,
        Month: row?.month,
        'Launch Name': row?.launchDetails?.launchName,
        'Launch Drop': row?.launchDetails?.launchDrop,
        'Launch Category': row?.launchDetails?.launchCategory,

        'Total Units': row?.totalUnits,
        'Total Option Qty': row?.totalOptionQty,
        'Product Categories': row?.productOptionDetails
          .map((category) => category?.poObject?.productCatName)
          .join(','),
        'OTB Type': row?.type,
        userName: row?.userDetails?.userName,
        CreatedDate: moment(row?.createdAt).format('DD/MM/YYYY') ?? 'NA',
        Status: getDisplayableStatus(row?.status),
      };
    });

    console.log(downloadDataFormatted, 'downloading data 2...');
    if (downloadDataFormatted?.length > 0) {
      return downloadDataFormatted;
    } else {
      return [
        {
          Id: 'NA',
          'Season ID': 'NA',
          Month: 'NA',
          'Launch Name': 'NA',
          'Launch Drop': 'NA',
          'Total Units': 'NA',
          'Total Option Qty': 'NA',
          'Product Categories': 'NA',
          'OTB Type': 'NA',
          userName: 'NA',
          CreatedDate: 'NA',
          Status: 'NA',
        },
      ];
    }
  };

  const generateProductOptionForAllselectedRecords = async () => {
    console.log(alreadySelectedRows, 'confirm all selected records func');
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/otb-record/generate-options`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Operation-Type': 'bulk',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          data: { selectedOTBRecords: alreadySelectedRows },
        }),
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData?.error) {
        errorHandler(responseData, message);
      } else {
        if (responseData?.data?.incompleteSuccess.length) {
          message.error(
            'Something went wrong, Please make sure All Selected records are confirmed before generating options',
          );
        } else {
          message.success('completed Product option generation');
        }
        // console.log(responseData);

        // fetchData(authToken);
        resetTable();
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h2>OTB Records Listing</h2>
      <Button
        data-test-id="add-new-details-page"
        onClick={() => {
          toOtbRecordDetails();
        }}
      >
        Add OTB Record
      </Button>

      {/* Table Section */}
      <div className="table">
        {/* Filter search Section */}
        <div className="filterContainer">
          <div className="tableSearchSection">
            <Select
              disabled={true}
              defaultValue="all"
              className="filterScopeSelect"
              onChange={handleFilterScopeChange}
              options={filterOptionArray}
            />

            <Input
              placeholder="Enter Search Text"
              onChange={handleChangeSearch}
              type="text"
              allowClear
              value={searchText}
            ></Input>
            <Button onClick={resetTable}>Reset</Button>
            <Button
              style={{ backgroundColor: 'greenyellow', color: 'white' }}
              onClick={getFinalFormatedData}
            >
              Download{' '}
              {isDownloading && (
                <Spin data-testid="spinner-downloading-data" size="small" />
              )}
            </Button>
            <CSVLink
              data={downloadableData}
              filename={
                'OTB-Record-list-' + moment(new Date()).format('DD-MM-YYYY')
              }
              ref={csvLinkRef}
              style={{ display: 'none' }}
            />
          </div>
        </div>

        {isLoading ? (
          <Spin data-test-id="spinner-loading-table" size="large" />
        ) : (
          <Table
            data-testid="data-table"
            dataSource={Data}
            columns={columns}
            onChange={handleTableChange}
            pagination={{
              current: currentPage,
              pageSize: paginationData?.pageSize,
              total: paginationData?.total,
              position: ['bottomCenter'],
            }}
            rowClassName={(record) =>
              record.type === 'planning-buy'
                ? 'planning-otb-record'
                : 'design-otb-record'
            }
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: alreadySelectedRows,
              onChange: (keys) => {
                setAlreadySelectedRows(keys);
              },
              getCheckboxProps: (record) => ({
                disabled: record.status === 'prod_option_generated',
                // Column configuration not to be checked
              }),

              onSelect: (record) => {
                console.log(record, 'selected row ');
              },
              selections: [
                Table.SELECTION_NONE,
                Table.SELECTION_ALL,

                {
                  key: 'confirmSelected',
                  text: 'Confirm All Selected Rows',
                  onSelect: (allkeys) => {
                    console.log('confirmSelected');
                    confirmAllselectedRecords();
                  },
                },
                {
                  key: 'generateProductOptions',
                  text: 'Generate Product Options',
                  onSelect: (allkeys) => {
                    console.log('confirmSelected');
                    generateProductOptionForAllselectedRecords();
                  },
                },
              ],
            }}
          />
        )}
      </div>
    </div>
  );
};

export default OtbRecordList;
